import { useQuery } from '@tanstack/react-query';
import { getReceivables } from '../services/financeService';

export const useReceivables = () => {
  return useQuery({
    queryKey: ['receivables'],
    queryFn: () => getReceivables().then(r => r.data),
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
  });
};
